import "./auto-center.css";
import { AutoCenter } from './auto-center';
export default AutoCenter;